module.exports = __webpack_public_path__ + "img/Logo2.dfc0da93.jpg";